import { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material";

import { Home, List, Logout, Map, Print, Report, Handshake, SettingsAccessibility,   ViewAgenda } from "@mui/icons-material";
import "../no-print.css";
import RootLayout from "../RootLayout";
const theme = createTheme({
	components: {
		MuiIcon: {
			styleOverrides: {
				root: {
					// Match 24px = 3 * 2 + 1.125 * 16
					color: "white",
					boxSizing: "content-box",
					padding: 3,
					fontSize: "1.125rem",
				},
			},
		},
	},
});
const getThemedIcon = ({ icon }) => {
	return <ThemeProvider theme={theme}>{icon}</ThemeProvider>;
};
const parkStaffMenuItems = [
	{ key: "home", to: "/", title: "Home", iconClass: getThemedIcon({ icon: <Home /> }) },
	
	{
		key: "GROUP",
		iconClass: <Handshake />,
		title: "Investor",
		detail: [

			{
				key: "GROUP",
				iconClass: <Handshake />,
				title: "Shed Handover",
				detail: [
					{ key: "registerHandover", to: "/registerHandover", title: "Register", iconClass: <Handshake /> },
					{ key: "viewHandover", to: "/viewHandover", title: "View", iconClass: <ViewAgenda /> },
				]
			},

			{
				key: "GROUP",
				iconClass: <Handshake />,
				title: "Land Handover",
				detail: [
					{ key: "registerHandoverland", to: "/registerHandoverland", title: "Register ", iconClass: <Handshake /> },
					
					{ key: "viewHandover", to: "/viewHandover", title: "View", iconClass: <ViewAgenda /> },
				]
			},

			
			{ key: "Inverstoractivities", to: "/inverstoractivities", title: "Inverstor activities", iconClass: < SettingsAccessibility /> },
			{
				key: "inverstoradvance",
				to: "/investoradvance",
				title: "Advance Payment",
			iconClass: <Handshake />,
		  },
		],
	  },
	  {
		key: "GROUP",
		iconClass: <Map />,
		title: "Map",
		detail: [
			
			{ key: "viewMap", to: "/viewMap", title: "View Map", iconClass: <Map /> },
			{ key: "viewMapByCategory", to: "/viewMapByCategory", title: "View Map by Category", iconClass: <Map /> },
			{ key: "printMap", to: "/printMap", title: "Print Map", iconClass: <Print /> },
		],
	  },

	  {
		key: "GROUP",
		iconClass: <List />,
		title: "List",
		detail: [
			
			{ key: "listParcel", to: "/listParcel", title: "Parcel ", iconClass: <List /> },
			{ key: "investorList", to: "/investorList", title: "Investor ", iconClass: <List /> },
			{ key: "investorList", to: "/agreementList", title: "Agreement ", iconClass: <List /> },
		],
	  },
	{ key: "parkReport", to: "/PASummaryReport", title: "Reports", iconClass: <Report /> },
	{ key: "myPreference", to: "/myPreference", title: "Preferences", iconClass: <SettingsAccessibility /> },
	{ key: "logout", to: "/logout", title: "Logout", iconClass: <Logout /> },
];

export default function ParkStaffLayout() {
	const [open, setOpen] = useState(true);
	const [showProfile, setShowProfile] = useState(true);
	return (
		<RootLayout
			department="Park Professional"
			open={open}
			setOpen={setOpen}
			showProfile={showProfile}
			setShowProfile={setShowProfile}
			menuList={parkStaffMenuItems}
		/>
	);
}
